'use client';

import type { DealershipAttrs } from '@core/Entities/Dealership/Dealership.entity';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import { Notification } from '@gds/Icons/Paths/Notification';

import type { LocationAttrs } from 'Components/SearchWidget/Search.entity';

import type { PlpFiltersMessagesProps } from '../Filters/FilterPanel.entity';
import { useSavedSearchForm } from './UseSavedSearchForm';

import styles from './SavedSearchForm.module.css';

interface SavedSearchPageCtaProps {
  locale: Locale;
  strings: PlpFiltersMessagesProps;
  locationAttrs?: LocationAttrs;
  dealerAttrs?: DealershipAttrs;
}

export const SavedSearchPageBellButton = ({
  locale,
  strings,
  locationAttrs,
  dealerAttrs,
}: SavedSearchPageCtaProps) => {
  const { openForm, canUseSavedSearch } = useSavedSearchForm({
    locale,
    strings,
    locationAttrs,
    dealerAttrs,
  });

  if (!canUseSavedSearch) return null;

  return (
    <button data-mobile-only="true" className={styles.pageBellButtonWrapper} onClick={openForm}>
      <Notification />
    </button>
  );
};

SavedSearchPageBellButton.displayName = 'SavedSearchPageBellButton';
